export class UpdateNewsletterTemplateModel {
    newsletterTemplateId : string;
    name: string;
    htmlContent: string;
    cssContent: string;
    templateContent: string;
    projectData : string;
}